import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import EventProvider from "./store/eventProvider";

// import {AmplifyAuthenticator, AmplifySignOut} from "@aws-amplify/ui-react";
Amplify.configure(awsconfig)

ReactDOM.render(
    <EventProvider>
        <App />
    </EventProvider>,
    // <AmplifyAuthenticator>
    // <div>
    //    <App />
    //    <AmplifySignOut />
    // </div>
    // </AmplifyAuthenticator>,
 document.getElementById('root'));

// https://docs.amplify.aws/ui-legacy/auth/authenticator/q/framework/react
// https://docs.amplify.aws/ui/auth/authenticator/q/framework/react#sign-in